import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { editEventVenue } from "../EventVenuesService";

function EventVenueDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    card: {
      marginTop: "20px",
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    image: {
      maxWidth: "100px",
      height: "auto",
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [clientId, setClientId] = useState("");
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [name, setName] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");
  const [id, setId] = useState("");

  function editVenue() {
    if (!checkAllEntered()) {
      setInputError(true);
      return;
    }
    let json = {
      Id: id,
      ClientId: clientId,
      Name: name,
      Address: address,
      City: city,
      Division: state,
      ZipCode: zipcode,
      Country: country,
      Website: website,
      PhoneNumber: phone,
      EmailAddress: email,
    };

    callAPI(
      editEventVenue(json),
      "Venue Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  const checkAllEntered = () => {
    if (
      name === "" ||
      address === "" ||
      city === "" ||
      state === "" ||
      zipcode === "" ||
      country === ""
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setName(location.state.name);
      setWebsite(location.state.website);
      setEmail(location.state.emailAddress);
      setPhone(location.state.phoneNumber);
      setAddress(location.state.address);
      setCity(location.state.city);
      setState(location.state.division);
      setZipcode(location.state.zipCode);
      setCountry(location.state.country);
      setClientId(location.state.clientId);
      setId(location.state.id);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/eventvenues" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/eventvenues" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <h1 className="page-title">
          {selectCareersClient.shortName} Event Venue Detailed
        </h1>
        <Breadcrumb />
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && name === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {inputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Website"
                      label="Website"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Email Address"
                      label="Email Address"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Phone Number"
                      label="Phone Number"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Address"
                      label="Address"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && address === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    {inputError && address === "" && (
                      <FormHelperText className={classes.error}>
                        Address Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="City"
                      label="City"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && city === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                    {inputError && city === "" && (
                      <FormHelperText className={classes.error}>
                        City Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="State/Division"
                      label="State/Division"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && state === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                    />
                    {inputError && state === "" && (
                      <FormHelperText className={classes.error}>
                        State/Division Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Zip Code"
                      label="Zip Code"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && zipcode === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={zipcode}
                      onChange={(e) => setZipcode(e.target.value)}
                    />
                    {inputError && zipcode === "" && (
                      <FormHelperText className={classes.error}>
                        Zip Code Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Country"
                      label="Country"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && country === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                    {inputError && country === "" && (
                      <FormHelperText className={classes.error}>
                        Country Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => editVenue()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default EventVenueDetailed;
